import i18n from '@/utils/i18n';
import moment from 'moment';
import React from 'react';
import { Label } from '@/components/label';
import { StyleProp, TextStyle } from 'react-native';
import { useTheme } from '@/contexts/theme-context';

export interface PromotionLabelType {
  expiresAt?: string | null;
  tagline?: string | null;
  uuid: string;
}

interface Props {
  promotion: PromotionLabelType;
  textStyle?: StyleProp<TextStyle>;
}

export const PromotionLabel: React.FC<Props> = ({ promotion, textStyle }) => {
  const theme = useTheme();

  let text: string;
  if (typeof promotion.tagline === 'string') {
    text = promotion.tagline;
  } else if (promotion.expiresAt) {
    const daysLeft = Math.max(
      moment(promotion.expiresAt).diff(moment(), 'days'),
      1,
    );

    text = i18n.t(daysLeft === 1 ? 'day_left' : 'days_left', {
      days: daysLeft,
    });
  } else {
    text = i18n.t('promotion_available');
  }

  return (
    <Label
      backgroundColor={theme.colors.promotionLabel}
      text={text}
      textStyle={textStyle}
    />
  );
};
